<template>
    <p>terms-and-conditions</p>
</template>

<script>
export default {
    name: 'TermsAndConditions'
}
</script>